// Layer 4 (UI) — the Maintenance route's shared table classes (polish.P21):
// the card-edge table the three tabs draw inside their cards, and the lead row
// the register's worst item and the selected monitoring point share.

import { cn } from '@/shared/cn';
import { CARD_TABLE, HOT_ROW } from '../downtime/DowntimeCard';

/** A card-edge table: the first and last cells meet the card's own padding. */
export const EDGE_TABLE = cn(
  CARD_TABLE,
  '[&_td:first-child]:pl-4 [&_th:first-child]:pl-4 [&_td:last-child]:pr-4 [&_th:last-child]:pr-4 [&_td]:align-top',
);

/** The lead row: the hot-row wash and a 2px crimson rule on its edge. */
export const LEAD_ROW = cn(HOT_ROW, '[&>td:first-child]:shadow-[inset_2px_0_0_var(--color-accent-500)]');
